import { IAppConfig } from 'ict24h-themes-react/lib/esm/App'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { Ict24hThemes } from 'ict24h-themes-react'
import CustomLayout from './CustomLayout'
import EOfficeLayoutRouters from '../e-office/modules/e-office-layout/EOfficeLayoutRouters'
import { E_OFFICE_PREFIX_URL } from '../e-office/modules/e-office-layout/constants/config.e-office-layout'

const localStorageKey =
  process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY || 'i24h-token-m365-hrm'

export const appConfig: IAppConfig = {
  authAPIEndpoint: ' https://approval.zbh-dev.i24h.app',
  localStorageKey,
  userAPIEndpoint: ' https://approval.zbh-dev.i24h.app/user', // NOTE: đang lỗi do app mobile của MS cũng dùng react native webview // isInMobileApp ? undefined : "ms-obh",
  routerType: 'browser',
}
export function HRMApp() {
  const routers: AppRouterItem[] = [
    {
      path: `/${E_OFFICE_PREFIX_URL}/*`,
      element: (
        <CustomLayout>
          <EOfficeLayoutRouters />
        </CustomLayout>
      ),
    },
  ]
  return <Ict24hThemes config={appConfig} appRouters={routers} />
}
